// extracted by mini-css-extract-plugin
export default {"locothinkingabouthosting11":"LocoThinkingAboutHosting_locothinkingabouthosting11__H+8Rw"};